import { render, staticRenderFns } from "./BDXEditFormYearOfAccount.vue?vue&type=template&id=09cbc49f"
import script from "./BDXEditFormYearOfAccount.vue?vue&type=script&lang=js"
export * from "./BDXEditFormYearOfAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports